/**
 * The review states a human may set on a bug or CVE.
 *
 * Must stay in step with BugCveReviewStatus in
 * service-rest-api/libs/validation_models.py — a state the backend accepts but
 * this list omits is a state no reviewer can choose. This list previously lived
 * inline in PlanPage.js, duplicated for bugs and CVEs, and had drifted to a
 * subset of the backend's vocabulary.
 */
export const BUG_CVE_REVIEW_STATES = [
  { value: 'Not reviewed', label: 'Not reviewed' },
  { value: 'Confirmed', label: 'Confirmed' },
  { value: 'Escalated for review', label: 'Escalated for review' },
  { value: 'Ignored', label: 'Ignored' },
  { value: 'Not applicable', label: 'Not applicable' },
  { value: 'Workaround identified', label: 'Workaround identified' },
  { value: 'Uncertain', label: 'Uncertain' },
  { value: 'Config removed', label: 'Config removed' }
];

/** Stored when a human deliberately marks an issue config-removed. */
export const CONFIG_REMOVED = 'Config removed';

/** The default state for a bug or CVE nobody has reviewed yet. */
export const NOT_REVIEWED = 'Not reviewed';

/**
 * The computed flavour. Never stored and never offered as a choice — it exists
 * only in the overlay, so the UI can show that the automation made this call
 * rather than a person.
 */
export const AUTO_CONFIG_REMOVED = 'Config removed (auto)';

/**
 * States that strike an issue out of the review list.
 *
 * The list already struck out 'Not applicable' and 'Ignored' with Bootstrap's
 * own `text-decoration-line-through`; both flavours of config-removed mean the
 * same thing to a reviewer ("this one is not yours to worry about"), so they
 * join the existing treatment rather than inventing a second one.
 */
export const STRUCK_OUT_STATES = ['Not applicable', 'Ignored', CONFIG_REMOVED, AUTO_CONFIG_REMOVED];

export const isStruckOut = value => STRUCK_OUT_STATES.includes(value);
